export const testIds = {
  HEADER: {
    PROFILE_PICTURE_ICON_BUTTON: 'open_profile_menu',
  },
  WORKOUT_DETAILS: {
    TRAINER_IMAGE: 'trainer_img',
  },
  WORKOUTS: {
    HIDE_COMPLETED_TOGGLE: 'hide_completed_workouts_toggle',
    OVERLAY: 'overlay',
  },
}

export const testIdAttribute = (label: string) => ({
  'data-test-id': label,
})
